import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Summa

  <span style="color:#85c1dc;">**FI:**</span>
  Summa

  <span style="color:#85c1dc;">**RU:**</span>
  Сумма
*/
/* @__NO_SIDE_EFFECTS__ */
const m912 = msg(
  mf`Summa`,
  mf`Summa`,
  mf`Сумма`,
)

export { m912 as 'w.basket.summary.total_price_mobile' }